const Alyglo = () => {
  return (
    <>
      <div>
        <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

        <p className="my-2">If you need copay assistance for your patient please visit ALYGLO Co-Pay Assistance Portal
          For Providers by clicking the button below. Eligible patients can receive up to $15,000 to cover the
          deductible, copay, and/or coinsurance for ALYGLO.</p>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE
        </div>

        <ul className="my-2 list-disc ml-10">
          <li>Patient must be a US resident</li>
          <li>Patient must express financial need</li>
          <li>Assistance is available to commercially insured patients only</li>
        </ul>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>Assistance covers only out-of-pocket expenses for the drug portion; administration supplies and nursing
            copay costs are not covered through the program
          </li>
          <li>Patients are ineligible for copay assistance if they participate in Medicare, Medicaid, Medigap, Veterans
            Affairs, Department of Defense, Tricare, or any other federal or state-funded programs.
          </li>
        </ul>
      </div>
    </>
  )
}

export default Alyglo